import { render, staticRenderFns } from "./ComplaintLog.vue?vue&type=template&id=5c726e16&scoped=true"
import script from "./ComplaintLog.vue?vue&type=script&lang=js"
export * from "./ComplaintLog.vue?vue&type=script&lang=js"
import style0 from "./ComplaintLog.vue?vue&type=style&index=0&id=5c726e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c726e16",
  null
  
)

export default component.exports